import React, { memo } from 'react';
import HomeTrickCard from "../HomeTrickCard/HomeTrickCard";

interface TrickCardItemProps {
    trick: any;  // Replace 'any' with the actual type of your item
    isAuthed: boolean;
    isCapacitor: boolean;
    userType: string;
    userId: string;
    publicId: string; // public cooresponds to the user that is logged in
    publicBisk: number;
    publicUsername: string;
    publicIsSubscribed: boolean;
    scrollSpeed: number;
    isScrolling: boolean;
}

const HomeTrickCardContainer: React.FC<TrickCardItemProps> = memo((props: TrickCardItemProps) => {
    const {
        trick,
        isAuthed,
        isCapacitor,
        userId,
        publicId,
        publicBisk,
        publicUsername,
        publicIsSubscribed,
        userType,
    } = props;

    return (
        <div className="flex flex-col justify-center items-center content-center">
            <HomeTrickCard
                trick={trick}
                isAuthed={isAuthed}
                isCapacitor={isCapacitor}
                userId={userId}
                userType={userType}
                publicId={publicId}
                publicBisk={publicBisk}
                publicUsername={publicUsername}
                publicIsSubscribed={publicIsSubscribed}
                isScrolling={props.isScrolling}
                scrollSpeed={props.scrollSpeed}
            />
        </div>
    );
});

export default HomeTrickCardContainer;
